/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { EmployeeAccessTypeDto } from '../models';
// @ts-ignore
import type { HrEventTypeDto } from '../models';
// @ts-ignore
import type { HrEventsResultDto } from '../models';
// @ts-ignore
import type { HrEventsSortByDto } from '../models';
// @ts-ignore
import type { HrEventsSummaryDto } from '../models';
// @ts-ignore
import type { InlineObjectDto } from '../models';
// @ts-ignore
import type { SortDirectionDto } from '../models';
/**
 * HrStatisticsApi - axios parameter creator
 * @export
 */
export const HrStatisticsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Agregaty do kafelkow i wykresow: headcount (stan biezacy vs 2 tyg. temu), headcount dzienny (14 dni wstecz), konczace sie umowy (14 dni wprzod), powroty z dlugotrwalej absencji, urodziny. Zawezone do podleglego obszaru.
         * @summary HR events summary (kafelki + wykresy)
         * @param {EmployeeAccessTypeDto} [accessType] Zakres widoczności pracowników (widok v_user_employee_access). Wartość domyślną ustala endpoint.
         * @param {Array<string>} [departmentCodes] Filtr po kolumnie current_department (wartosci enuma Department).
         * @param {Array<string>} [regionCodes] Filtr po kolumnie region_code (slownik dict_region).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHrEventsSummary: async (accessType?: EmployeeAccessTypeDto, departmentCodes?: Array<string>, regionCodes?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/hr/events/summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (accessType !== undefined) {
                localVarQueryParameter['accessType'] = accessType;
            }

            if (departmentCodes) {
                localVarQueryParameter['departmentCodes'] = departmentCodes.join(COLLECTION_FORMATS.csv);
            }

            if (regionCodes) {
                localVarQueryParameter['regionCodes'] = regionCodes.join(COLLECTION_FORMATS.csv);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lista osob z pojedynczym zdarzeniem kadrowym (HIRED / CONTRACT_ENDING / ABSENCE_RETURN / BIRTHDAY), zawezona do podleglego obszaru zalogowanego uzytkownika (v_user_employee_access). Klik w slupek wykresu => dateFrom=dateTo (jeden dzien).
         * @summary Paginated list of employees with an HR event (osoba + event)
         * @param {HrEventTypeDto} eventType 
         * @param {number} page 
         * @param {number} pageSize 
         * @param {EmployeeAccessTypeDto} [accessType] Zakres widoczności pracowników (widok v_user_employee_access). Wartość domyślną ustala endpoint.
         * @param {string} [dateFrom] 
         * @param {string} [dateTo] 
         * @param {Array<string>} [departmentCodes] Filtr po kolumnie current_department (wartosci enuma Department).
         * @param {Array<string>} [regionCodes] Filtr po kolumnie region_code (slownik dict_region).
         * @param {string} [search] Szukanie po imieniu/nazwisku.
         * @param {SortDirectionDto} [sortOrder] 
         * @param {HrEventsSortByDto} [sortBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listHrEvents: async (eventType: HrEventTypeDto, page: number, pageSize: number, accessType?: EmployeeAccessTypeDto, dateFrom?: string, dateTo?: string, departmentCodes?: Array<string>, regionCodes?: Array<string>, search?: string, sortOrder?: SortDirectionDto, sortBy?: HrEventsSortByDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventType' is not null or undefined
            assertParamExists('listHrEvents', 'eventType', eventType)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('listHrEvents', 'page', page)
            // verify required parameter 'pageSize' is not null or undefined
            assertParamExists('listHrEvents', 'pageSize', pageSize)
            const localVarPath = `/api/v2/hr/events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (eventType !== undefined) {
                localVarQueryParameter['eventType'] = eventType;
            }

            if (accessType !== undefined) {
                localVarQueryParameter['accessType'] = accessType;
            }

            if (dateFrom !== undefined) {
                localVarQueryParameter['dateFrom'] = (dateFrom as any instanceof Date) ?
                    (dateFrom as any).toISOString().substring(0,10) :
                    dateFrom;
            }

            if (dateTo !== undefined) {
                localVarQueryParameter['dateTo'] = (dateTo as any instanceof Date) ?
                    (dateTo as any).toISOString().substring(0,10) :
                    dateTo;
            }

            if (departmentCodes) {
                localVarQueryParameter['departmentCodes'] = departmentCodes.join(COLLECTION_FORMATS.csv);
            }

            if (regionCodes) {
                localVarQueryParameter['regionCodes'] = regionCodes.join(COLLECTION_FORMATS.csv);
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HrStatisticsApi - functional programming interface
 * @export
 */
export const HrStatisticsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = HrStatisticsApiAxiosParamCreator(configuration)
    return {
        /**
         * Agregaty do kafelkow i wykresow: headcount (stan biezacy vs 2 tyg. temu), headcount dzienny (14 dni wstecz), konczace sie umowy (14 dni wprzod), powroty z dlugotrwalej absencji, urodziny. Zawezone do podleglego obszaru.
         * @summary HR events summary (kafelki + wykresy)
         * @param {EmployeeAccessTypeDto} [accessType] Zakres widoczności pracowników (widok v_user_employee_access). Wartość domyślną ustala endpoint.
         * @param {Array<string>} [departmentCodes] Filtr po kolumnie current_department (wartosci enuma Department).
         * @param {Array<string>} [regionCodes] Filtr po kolumnie region_code (slownik dict_region).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHrEventsSummary(accessType?: EmployeeAccessTypeDto, departmentCodes?: Array<string>, regionCodes?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HrEventsSummaryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getHrEventsSummary(accessType, departmentCodes, regionCodes, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HrStatisticsApi.getHrEventsSummary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Lista osob z pojedynczym zdarzeniem kadrowym (HIRED / CONTRACT_ENDING / ABSENCE_RETURN / BIRTHDAY), zawezona do podleglego obszaru zalogowanego uzytkownika (v_user_employee_access). Klik w slupek wykresu => dateFrom=dateTo (jeden dzien).
         * @summary Paginated list of employees with an HR event (osoba + event)
         * @param {HrEventTypeDto} eventType 
         * @param {number} page 
         * @param {number} pageSize 
         * @param {EmployeeAccessTypeDto} [accessType] Zakres widoczności pracowników (widok v_user_employee_access). Wartość domyślną ustala endpoint.
         * @param {string} [dateFrom] 
         * @param {string} [dateTo] 
         * @param {Array<string>} [departmentCodes] Filtr po kolumnie current_department (wartosci enuma Department).
         * @param {Array<string>} [regionCodes] Filtr po kolumnie region_code (slownik dict_region).
         * @param {string} [search] Szukanie po imieniu/nazwisku.
         * @param {SortDirectionDto} [sortOrder] 
         * @param {HrEventsSortByDto} [sortBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listHrEvents(eventType: HrEventTypeDto, page: number, pageSize: number, accessType?: EmployeeAccessTypeDto, dateFrom?: string, dateTo?: string, departmentCodes?: Array<string>, regionCodes?: Array<string>, search?: string, sortOrder?: SortDirectionDto, sortBy?: HrEventsSortByDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HrEventsResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listHrEvents(eventType, page, pageSize, accessType, dateFrom, dateTo, departmentCodes, regionCodes, search, sortOrder, sortBy, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HrStatisticsApi.listHrEvents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * HrStatisticsApi - factory interface
 * @export
 */
export const HrStatisticsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = HrStatisticsApiFp(configuration)
    return {
        /**
         * Agregaty do kafelkow i wykresow: headcount (stan biezacy vs 2 tyg. temu), headcount dzienny (14 dni wstecz), konczace sie umowy (14 dni wprzod), powroty z dlugotrwalej absencji, urodziny. Zawezone do podleglego obszaru.
         * @summary HR events summary (kafelki + wykresy)
         * @param {EmployeeAccessTypeDto} [accessType] Zakres widoczności pracowników (widok v_user_employee_access). Wartość domyślną ustala endpoint.
         * @param {Array<string>} [departmentCodes] Filtr po kolumnie current_department (wartosci enuma Department).
         * @param {Array<string>} [regionCodes] Filtr po kolumnie region_code (slownik dict_region).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHrEventsSummary(accessType?: EmployeeAccessTypeDto, departmentCodes?: Array<string>, regionCodes?: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<HrEventsSummaryDto> {
            return localVarFp.getHrEventsSummary(accessType, departmentCodes, regionCodes, options).then((request) => request(axios, basePath));
        },
        /**
         * Lista osob z pojedynczym zdarzeniem kadrowym (HIRED / CONTRACT_ENDING / ABSENCE_RETURN / BIRTHDAY), zawezona do podleglego obszaru zalogowanego uzytkownika (v_user_employee_access). Klik w slupek wykresu => dateFrom=dateTo (jeden dzien).
         * @summary Paginated list of employees with an HR event (osoba + event)
         * @param {HrEventTypeDto} eventType 
         * @param {number} page 
         * @param {number} pageSize 
         * @param {EmployeeAccessTypeDto} [accessType] Zakres widoczności pracowników (widok v_user_employee_access). Wartość domyślną ustala endpoint.
         * @param {string} [dateFrom] 
         * @param {string} [dateTo] 
         * @param {Array<string>} [departmentCodes] Filtr po kolumnie current_department (wartosci enuma Department).
         * @param {Array<string>} [regionCodes] Filtr po kolumnie region_code (slownik dict_region).
         * @param {string} [search] Szukanie po imieniu/nazwisku.
         * @param {SortDirectionDto} [sortOrder] 
         * @param {HrEventsSortByDto} [sortBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listHrEvents(eventType: HrEventTypeDto, page: number, pageSize: number, accessType?: EmployeeAccessTypeDto, dateFrom?: string, dateTo?: string, departmentCodes?: Array<string>, regionCodes?: Array<string>, search?: string, sortOrder?: SortDirectionDto, sortBy?: HrEventsSortByDto, options?: RawAxiosRequestConfig): AxiosPromise<HrEventsResultDto> {
            return localVarFp.listHrEvents(eventType, page, pageSize, accessType, dateFrom, dateTo, departmentCodes, regionCodes, search, sortOrder, sortBy, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * HrStatisticsApi - interface
 * @export
 * @interface HrStatisticsApi
 */
export interface HrStatisticsApiInterface {
    /**
     * Agregaty do kafelkow i wykresow: headcount (stan biezacy vs 2 tyg. temu), headcount dzienny (14 dni wstecz), konczace sie umowy (14 dni wprzod), powroty z dlugotrwalej absencji, urodziny. Zawezone do podleglego obszaru.
     * @summary HR events summary (kafelki + wykresy)
     * @param {EmployeeAccessTypeDto} [accessType] Zakres widoczności pracowników (widok v_user_employee_access). Wartość domyślną ustala endpoint.
     * @param {Array<string>} [departmentCodes] Filtr po kolumnie current_department (wartosci enuma Department).
     * @param {Array<string>} [regionCodes] Filtr po kolumnie region_code (slownik dict_region).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HrStatisticsApiInterface
     */
    getHrEventsSummary(accessType?: EmployeeAccessTypeDto, departmentCodes?: Array<string>, regionCodes?: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<HrEventsSummaryDto>;

    /**
     * Lista osob z pojedynczym zdarzeniem kadrowym (HIRED / CONTRACT_ENDING / ABSENCE_RETURN / BIRTHDAY), zawezona do podleglego obszaru zalogowanego uzytkownika (v_user_employee_access). Klik w slupek wykresu => dateFrom=dateTo (jeden dzien).
     * @summary Paginated list of employees with an HR event (osoba + event)
     * @param {HrEventTypeDto} eventType 
     * @param {number} page 
     * @param {number} pageSize 
     * @param {EmployeeAccessTypeDto} [accessType] Zakres widoczności pracowników (widok v_user_employee_access). Wartość domyślną ustala endpoint.
     * @param {string} [dateFrom] 
     * @param {string} [dateTo] 
     * @param {Array<string>} [departmentCodes] Filtr po kolumnie current_department (wartosci enuma Department).
     * @param {Array<string>} [regionCodes] Filtr po kolumnie region_code (slownik dict_region).
     * @param {string} [search] Szukanie po imieniu/nazwisku.
     * @param {SortDirectionDto} [sortOrder] 
     * @param {HrEventsSortByDto} [sortBy] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HrStatisticsApiInterface
     */
    listHrEvents(eventType: HrEventTypeDto, page: number, pageSize: number, accessType?: EmployeeAccessTypeDto, dateFrom?: string, dateTo?: string, departmentCodes?: Array<string>, regionCodes?: Array<string>, search?: string, sortOrder?: SortDirectionDto, sortBy?: HrEventsSortByDto, options?: RawAxiosRequestConfig): AxiosPromise<HrEventsResultDto>;

}

/**
 * HrStatisticsApi - object-oriented interface
 * @export
 * @class HrStatisticsApi
 * @extends {BaseAPI}
 */
export class HrStatisticsApi extends BaseAPI implements HrStatisticsApiInterface {
    /**
     * Agregaty do kafelkow i wykresow: headcount (stan biezacy vs 2 tyg. temu), headcount dzienny (14 dni wstecz), konczace sie umowy (14 dni wprzod), powroty z dlugotrwalej absencji, urodziny. Zawezone do podleglego obszaru.
     * @summary HR events summary (kafelki + wykresy)
     * @param {EmployeeAccessTypeDto} [accessType] Zakres widoczności pracowników (widok v_user_employee_access). Wartość domyślną ustala endpoint.
     * @param {Array<string>} [departmentCodes] Filtr po kolumnie current_department (wartosci enuma Department).
     * @param {Array<string>} [regionCodes] Filtr po kolumnie region_code (slownik dict_region).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HrStatisticsApi
     */
    public getHrEventsSummary(accessType?: EmployeeAccessTypeDto, departmentCodes?: Array<string>, regionCodes?: Array<string>, options?: RawAxiosRequestConfig) {
        return HrStatisticsApiFp(this.configuration).getHrEventsSummary(accessType, departmentCodes, regionCodes, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lista osob z pojedynczym zdarzeniem kadrowym (HIRED / CONTRACT_ENDING / ABSENCE_RETURN / BIRTHDAY), zawezona do podleglego obszaru zalogowanego uzytkownika (v_user_employee_access). Klik w slupek wykresu => dateFrom=dateTo (jeden dzien).
     * @summary Paginated list of employees with an HR event (osoba + event)
     * @param {HrEventTypeDto} eventType 
     * @param {number} page 
     * @param {number} pageSize 
     * @param {EmployeeAccessTypeDto} [accessType] Zakres widoczności pracowników (widok v_user_employee_access). Wartość domyślną ustala endpoint.
     * @param {string} [dateFrom] 
     * @param {string} [dateTo] 
     * @param {Array<string>} [departmentCodes] Filtr po kolumnie current_department (wartosci enuma Department).
     * @param {Array<string>} [regionCodes] Filtr po kolumnie region_code (slownik dict_region).
     * @param {string} [search] Szukanie po imieniu/nazwisku.
     * @param {SortDirectionDto} [sortOrder] 
     * @param {HrEventsSortByDto} [sortBy] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HrStatisticsApi
     */
    public listHrEvents(eventType: HrEventTypeDto, page: number, pageSize: number, accessType?: EmployeeAccessTypeDto, dateFrom?: string, dateTo?: string, departmentCodes?: Array<string>, regionCodes?: Array<string>, search?: string, sortOrder?: SortDirectionDto, sortBy?: HrEventsSortByDto, options?: RawAxiosRequestConfig) {
        return HrStatisticsApiFp(this.configuration).listHrEvents(eventType, page, pageSize, accessType, dateFrom, dateTo, departmentCodes, regionCodes, search, sortOrder, sortBy, options).then((request) => request(this.axios, this.basePath));
    }
}

